import React, { useState, useEffect, useRef } from "react";
import {useSelector, useDispatch} from 'react-redux';
import { useSnackbar } from 'notistack';
import { green, indigo, orange, red  } from "@material-ui/core/colors";
import GridItem from "components/Grid/GridItem.js";
import {Button, TextField, Grid} from "@material-ui/core/";
import FirstPart from "./Components/FirstPart";
import NavPills from "components/NavPills/NavPills.js";
import Motivo from "./Components/Motivo";
import Tipo from "./Components/Tipo";
import Origen from "./Components/Origen";
import Profesionales from "./Components/Profesionales";
import api from "utils/API";
import apiform from "utils/APIForm";
import moment from "moment-timezone";
import {
  getListRequestPatient,
} from 'actions/getListAction';


import ModalDialog from "views/Widgets/Common/ModalDialog";

const ModalRequestTraslate = props => {
  const dispatch = useDispatch()
  const { openModal, closeModal, dataPatient } = props;
  const [regiones, setRegiones] = useState([]);
  const [comunas, setComunas] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const [professionalSelected, setProfessionalSelected] = useState(false);
  const [sendApproval, setSendApproval] = useState(false);
  const [transferQuantity, setTransferQuantity] = useState({});
  const [firstCharge, setFirstCharge] = useState(true);
  const [tabSection, setTabSection] = useState(0);
  const [reason, setReason] = useState("");
  const [reasons, setReasons] = useState("");
  const [indications, setIndications] = useState("");
  const [transferType, setTransferType] = useState("Auto");
  const [origin, setOrigin] = useState("");
  const [originDate, setOriginDate] = useState("");
  const [originStreet, setOriginStreet] = useState("");
  const [originNumber, setOriginNumber] = useState("");
  const [originDepto, setOriginDepto] = useState("");
  const [originBlock, setOriginBlock] = useState("");
  const [originCity, setOriginCity] = useState("");
  const [originComuna, setOriginComuna] = useState("");
  const [originRegion, setOriginRegion] = useState("");
  const [originDescription, setOriginDescription] = useState("");
  const [originComments, setOriginComments] = useState("");
  const [originGoing, setoriginGoing] = useState(true)
  const [originReturn, setoriginReturn] = useState(true)
  const [amounts, setamounts] = useState({})
  const [fileRequestExam, setFilesRequestExam] = useState(null);
  const [fileFichaClinica, setFileFichaClinica] = useState(null);
  const [requiereFormularioIsapre, setRequiereFormularioIsapre] = useState(false);
  const [fileFormularioIsapre, setFileFormularioIsapre] = useState(null);

  const [destination, setDestination] = useState("");
  const [destinationDate, setDestinationDate] = useState("");
  const [destinationStreet, setDestinationStreet] = useState("");
  const [destinationNumber, setDestinationNumber] = useState("");
  const [destinationDepto, setDestinationDepto] = useState("");
  const [destinationBlock, setDestinationBlock] = useState("");
  const [destinationCity, setDestinationCity] = useState("");
  const [destinationComuna, setDestinationComuna] = useState("");
  const [destinationRegion, setDestinationRegion] = useState("");
  const [destinationDescription, setDestinationDescription] = useState("");
  const [destinationComments, setDestinationComments] = useState("");
  const [waitPatient, setwaitPatient] = useState(true);

  const dictTab = {
    "0": "motivo",
    "1": "tipo",
    "2": "origen",
    "3": "profesionales",
  }

  const [transferPrice, setTransferPrice] = useState(0);

  const viewOnly = false;

  const compareProfessionals = [];
  const checkProfessionals = [];
  const [deleteProfessionals, setDeleteProfessionals] = useState([]);
  const [addProfessionals, setAddProfessionals] = useState([]);
  const [editProfessionals, setEditProfessionals] = useState([]);

  const [sending, setsending] = useState(false);
  const createdRequestIdRef = useRef(null);
  const uploadedDocRef = useRef(null);
  const uploadedFichaClinicaRef = useRef(null);
  const uploadedFormularioIsapreRef = useRef(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = key => (
    <Button style={{background: "#af4c4c00", color: "#fff"}} onClick={() => {closeSnackbar(key)}}>
        CERRAR
    </Button>
  );

  const handleSnakeMessage = (message, variant, vertical= "top", hotizontal="center", persist=false) => {
    enqueueSnackbar(
        message,
        {
            variant,
            persist: persist,
            action,
            preventDuplicate: true,
            anchorOrigin: {
                vertical: vertical,
                horizontal: hotizontal,
            },
        }
    );
  };

  useEffect(() => {
    if (firstCharge) {
      initialCharge();
    }
  });

  useEffect(() => {
    api.get(`api/paciente/${dataPatient.id}/solicitudes/extras/requisitosdocumentos/`).then((response) => {
      setRequiereFormularioIsapre(response.data.requiere_formulario_isapre);
    }).catch(() => {});
  }, [])

  useEffect(() => {
    checkFileSendApproval();
    if (!originGoing & !originReturn){
      setoriginReturn(true);
      setoriginGoing(true);

    }
  }, [originGoing, originReturn]);

  const checkFileSendApproval = (argAmount=null) => {
    const tempAmount = argAmount || amounts
    if (originGoing && originReturn){
      if (tempAmount.cantidad_pedida_ida_vuelta >= tempAmount.cantidad_asignada_ida_vuelta) {
        setSendApproval(true);
      } else {
        setSendApproval(false);
      }
      setTransferQuantity({cantidad_pedida: tempAmount.cantidad_pedida_ida_vuelta, cantidad_asignada: tempAmount.cantidad_asignada_ida_vuelta});
    } else if (originGoing) {
      if (tempAmount.cantidad_pedida_ida >= tempAmount.cantidad_asignada_ida) {
        setSendApproval(true);
      } else {
        setSendApproval(false);
      }
      setTransferQuantity({cantidad_pedida: amounts.cantidad_pedida_ida, cantidad_asignada: amounts.cantidad_asignada_ida});
    } else if (originReturn) {
      if (tempAmount.cantidad_pedida_vuelta >= tempAmount.cantidad_asignada_vuelta) {
        setSendApproval(true);
      } else {
        setSendApproval(false);
      }
      setTransferQuantity({cantidad_pedida: amounts.cantidad_pedida_vuelta, cantidad_asignada: amounts.cantidad_asignada_vuelta});
    }

  }

  const initialCharge = () => {
    setFirstCharge(false);
    const getRegiones = api.get("api/locaciones/regiones/");
    const getProfessionals = api.get(`api/paciente/${dataPatient.id}/solicitudes/traslados/datosbase/`);

    Promise.all([getRegiones, getProfessionals])
      .then(response => {
        let tempRegiones = [];
        response[0].data.map(row => {
          tempRegiones.push({
            value: row.id,
            label: row.nombre
          });
        });
        let tempProfessionals = [];
        response[1].data.cargos.map(row => {
          tempProfessionals.push({
            id: row.id,
            name: row.nombre_corto,
            selected: false,
            cantidad: 1
          });
        });
        const tempAmounts= response[1].data.cantidades
        checkFileSendApproval(tempAmounts)
        setamounts(tempAmounts)
        setProfessionals(tempProfessionals);
        setRegiones(tempRegiones);

      })

  };

  const sendRequest = save => {
    if (sending) {
      return;
    }
    setsending(true);

    let tempProfessionals = [];
    professionals
      .filter(professional => professional.selected)
      .map(row => {
        tempProfessionals.push({
          cantidad: row.cantidad,
          id_cargo: row.id
        });
      });

    let send = {
      tipo_motivo_traslado: reason,
      indicaciones_generales: indications,
      tipo_traslado: transferType,
      fecha_hora_inicio: moment(originDate).format("YYYY-MM-DDTHH:mm:ss"),
      calle_inicio: originStreet,
      numero_inicio: originNumber,
      ciudad_inicio: originCity,
      comuna_inicio: originComuna.label,
      region_inicio: originRegion.label,
      fecha_hora_fin: moment(destinationDate).format("YYYY-MM-DDTHH:mm:ss"),
      calle_fin: destinationStreet,
      numero_fin: destinationNumber,
      ciudad_fin: destinationCity,
      comuna_fin: destinationComuna.label,
      region_fin: destinationRegion.label,
      esperar_paciente: waitPatient,
      profesionales_solicitados: tempProfessionals,
      texto_motivo_traslado: reasons,
      valor_traslado: transferPrice,
      depto_casa_inicio: originDepto,
      block_inicio: originBlock,
      comentarios_inicio: originComments,
      depto_casa_fin: destinationDepto,
      block_fin: destinationBlock,
      ida: originGoing,
      vuelta: originReturn,
      extra: sendApproval
    };

    const getRequestId = createdRequestIdRef.current
      ? Promise.resolve(createdRequestIdRef.current)
      : api.post(`/api/paciente/${dataPatient.id}/solicitudes/traslados/`, send).then(response => {
          createdRequestIdRef.current = response.data.id;
          return response.data.id;
        });

    getRequestId.then(requestId => {
      const finishSuccess = () => {
        handleSnakeMessage("Solicitud de traslado generada con éxito", "success");
        getListRequestPatient(dataPatient, dispatch);
        createdRequestIdRef.current = null;
        uploadedDocRef.current = null;
        uploadedFichaClinicaRef.current = null;
        uploadedFormularioIsapreRef.current = null;
        setsending(false);
        closeModal();
      };

      if (!save) {
        finishSuccess();
        return;
      }

      const getDocument = fileRequestExam == null
        ? Promise.resolve(null)
        : (uploadedDocRef.current && uploadedDocRef.current.file === fileRequestExam[0])
        ? Promise.resolve(uploadedDocRef.current.data)
        : (() => {
            const formData = new FormData();
            formData.append("archivo", fileRequestExam[0]);
            formData.append("tipo_documento", "OrdenTraslado");
            formData.append("nombre_archivo", fileRequestExam[0].name);
            formData.append("id_paciente", dataPatient.id);
            formData.append("id_solicitud_paciente", parseInt(requestId));
            return apiform.post(`/api/documentospaciente/`, formData).then(response => {
              uploadedDocRef.current = { file: fileRequestExam[0], data: response.data };
              return response.data;
            });
          })();

      const getFichaClinica = fileFichaClinica == null
        ? Promise.resolve(null)
        : (uploadedFichaClinicaRef.current && uploadedFichaClinicaRef.current.file === fileFichaClinica[0])
        ? Promise.resolve(uploadedFichaClinicaRef.current.data)
        : (() => {
            const formData = new FormData();
            formData.append("archivo", fileFichaClinica[0]);
            formData.append("tipo_documento", "FichaClinica");
            formData.append("nombre_archivo", fileFichaClinica[0].name);
            formData.append("id_paciente", dataPatient.id);
            formData.append("id_solicitud_paciente", parseInt(requestId));
            return apiform.post(`/api/documentospaciente/`, formData).then(response => {
              uploadedFichaClinicaRef.current = { file: fileFichaClinica[0], data: response.data };
              return response.data;
            });
          })();

      const getFormularioIsapre = (!requiereFormularioIsapre || fileFormularioIsapre == null)
        ? Promise.resolve(null)
        : (uploadedFormularioIsapreRef.current && uploadedFormularioIsapreRef.current.file === fileFormularioIsapre[0])
        ? Promise.resolve(uploadedFormularioIsapreRef.current.data)
        : (() => {
            const formData = new FormData();
            formData.append("archivo", fileFormularioIsapre[0]);
            formData.append("tipo_documento", "FormularioSolicitudExtraIsapre");
            formData.append("nombre_archivo", fileFormularioIsapre[0].name);
            formData.append("id_paciente", dataPatient.id);
            formData.append("id_solicitud_paciente", parseInt(requestId));
            return apiform.post(`/api/documentospaciente/`, formData).then(response => {
              uploadedFormularioIsapreRef.current = { file: fileFormularioIsapre[0], data: response.data };
              return response.data;
            });
          })();

      // El PUT de envío valida en el backend que los documentos ya existan
      // (ej. ficha clínica) — tiene que ir DESPUÉS de que las subidas terminen,
      // no en paralelo (Promise.all no garantiza que las subidas terminen
      // antes de que el PUT llegue al backend y haga esa validación).
      Promise.all([getDocument, getFichaClinica, getFormularioIsapre]).then(() => {
        return api.put(`/api/paciente/${dataPatient.id}/solicitudes/traslados/${requestId}/enviar/`);
      }).then(() => {
        finishSuccess();
      }).catch(() => {
        handleSnakeMessage("La solicitud fue creada pero no se pudo enviar. Intente nuevamente.", "error");
        setsending(false);
      });
    }).catch(() => {
      handleSnakeMessage("No se pudo generar la solicitud de traslado. Intente nuevamente.", "error");
      createdRequestIdRef.current = null;
      setsending(false);
    });
  };

  const validateSend = reason !== "" && indications !== "" && transferType !== "" && originStreet !== "" && originNumber !== "" && originRegion !== "" && originComuna !== "" && 
    originCity !== "" && destinationStreet !== "" && destinationNumber !== "" && destinationRegion !== "" && destinationComuna !== "" && (originGoing || originReturn ) && 
    professionalSelected && originDate !== "" && originStreet !== "" && originCity !== "" && originComuna !== "" && originRegion !== "" &&
    destinationDate !== "" && destinationStreet !== "" && destinationCity !== "" && destinationComuna !== "" && destinationRegion !== ""

  const _content_ =  <div>
  <FirstPart
    dataPatient={dataPatient}
    transferPrice={transferPrice}
    setTransferPrice={setTransferPrice}
    transferQuantity={transferQuantity}
    originGoing={originGoing}
    originReturn={originReturn}
  />
    <GridItem xs={12}>
      <Grid item container xs={12} justify="center">
          <Grid
            item
            container
            xs={12}
            justify="center"
            style={{ marginBottom: "4px" }}
          >
            <span>
              {fileRequestExam === null ? "Orden de traslado (opcional)" : fileRequestExam[0].name}{" "}

            </span>
          </Grid>
          <Button
            variant="contained"
            component="label"
            color="primary"
            style={{ textTransform: "none", marginRight: "3px" }}
          >
            Adjuntar orden de traslado
            <TextField
              type="file"
              id="exam"
              onChange={(event) => {
                uploadedDocRef.current = null;
                setFilesRequestExam(event.target.files);
              }}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
        </Grid>
        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginBottom: "4px", marginTop: "8px" }}
        >
          <span>
            {fileFichaClinica === null ? "Ficha clínica (opcional)" : fileFichaClinica[0].name}{" "}
          </span>
        </Grid>
        <Grid item container xs={12} justify="center">
          <Button
            variant="contained"
            component="label"
            color="primary"
            style={{ textTransform: "none", marginRight: "3px" }}
          >
            Adjuntar ficha clínica
            <TextField
              type="file"
              id="ficha-clinica-traslado"
              onChange={(event) => {
                uploadedFichaClinicaRef.current = null;
                setFileFichaClinica(event.target.files);
              }}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
        </Grid>
        {requiereFormularioIsapre &&
        <>
        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginBottom: "4px", marginTop: "8px" }}
        >
          <span>
            {fileFormularioIsapre === null ? "Formulario de solicitudes extras (Isapre) recomendado (opcional)" : fileFormularioIsapre[0].name}{" "}
          </span>
        </Grid>
        <Grid item container xs={12} justify="center">
          <Button
            variant="contained"
            component="label"
            color="primary"
            style={{ textTransform: "none", marginRight: "3px" }}
          >
            Adjuntar formulario de solicitudes extras
            <TextField
              type="file"
              id="formulario-isapre-traslado"
              onChange={(event) => {
                uploadedFormularioIsapreRef.current = null;
                setFileFormularioIsapre(event.target.files);
              }}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
        </Grid>
        </>
        }
    </GridItem>
    <GridItem xs={12}>
      <NavPills
        color="primary"
        alignCenter
        tabs={[
            {
            tabButton: "1. Motivo traslado",
            tabContent: (
              <Motivo
                reason={reason}
                setReason={setReason}
                reasons={reasons}
                setReasons={setReasons}
                indications={indications}
                setIndications={setIndications}
                viewOnly={viewOnly}
              />

            )},
            {
            tabButton: "2. Tipo de traslado",
            tabContent: (
              <Tipo
                transferType={transferType}
                setTransferType={setTransferType}
                originGoing={originGoing}
                setoriginGoing={setoriginGoing}
                originReturn={originReturn}
                setoriginReturn={setoriginReturn}
                viewOnly={viewOnly}
              />
            )},
            {
            tabButton: "3. Origen y destino",
            tabContent: (
              <Origen
              dataPatient={dataPatient}
              regiones={regiones}
              comunas={comunas}
              setComunas={setComunas}
              origin={origin}
              setOrigin={setOrigin}
              originDate={originDate}
              setOriginDate={setOriginDate}
              originStreet={originStreet}
              setOriginStreet={setOriginStreet}
              originNumber={originNumber}
              setOriginNumber={setOriginNumber}
              originDepto={originDepto}
              setOriginDepto={setOriginDepto}
              originBlock={originBlock}
              setOriginBlock={setOriginBlock}
              originCity={originCity}
              setOriginCity={setOriginCity}
              originComuna={originComuna}
              setOriginComuna={setOriginComuna}
              originRegion={originRegion}
              setOriginRegion={setOriginRegion}
              originDescription={originDescription}
              setOriginDescription={setOriginDescription}
              originComments={originComments}
              setOriginComments={setOriginComments}
              destination={destination}
              setDestination={setDestination}
              destinationDate={destinationDate}
              setDestinationDate={setDestinationDate}
              destinationStreet={destinationStreet}
              setDestinationStreet={setDestinationStreet}
              destinationNumber={destinationNumber}
              setDestinationNumber={setDestinationNumber}
              destinationDepto={destinationDepto}
              setDestinationDepto={setDestinationDepto}
              destinationBlock={destinationBlock}
              setDestinationBlock={setDestinationBlock}
              destinationCity={destinationCity}
              setDestinationCity={setDestinationCity}
              destinationComuna={destinationComuna}
              setDestinationComuna={setDestinationComuna}
              destinationRegion={destinationRegion}
              setDestinationRegion={setDestinationRegion}
              destinationDescription={destinationDescription}
              setDestinationDescription={setDestinationDescription}
              destinationComments={destinationComments}
              setDestinationComments={setDestinationComments}
              waitPatient={waitPatient}
              setwaitPatient={setwaitPatient}
              viewOnly={viewOnly}
            />
            )},
            {
                tabButton: "4. Profesionales clinicos",
                tabContent: <Profesionales
                  professionals={professionals}
                  setProfessionals={setProfessionals}
                  professionalSelected={professionalSelected}
                  setProfessionalSelected={setProfessionalSelected}
                  viewOnly={viewOnly}
                  compareProfessionals={[...compareProfessionals]}
                  checkProfessionals={checkProfessionals}
                  addProfessionals={addProfessionals}
                  setAddProfessionals={setAddProfessionals}
                  deleteProfessionals={deleteProfessionals}
                  setDeleteProfessionals={setDeleteProfessionals}
                  editProfessionals={editProfessionals}
                  setEditProfessionals={setEditProfessionals}
              />

            }
        ]}
        onClick={setTabSection}
        updateTab={tabSection}
      />
      </GridItem>
</div>

const backTab = tabSection-1;
const nextTab = tabSection+1;


const _actions_ = <>
   {dictTab[backTab.toString()] &&
    <Button
      variant="contained"
      color="primary"
      style={{background: red[500]}}
      onClick={() => setTabSection(backTab)}
    >
      Atras
    </Button>
    }
  {dictTab[nextTab.toString()] &&
    <Button
      variant="contained"
      color="primary"
      style={{background: green[500]}}
      onClick={() => setTabSection(nextTab)}
    >
      Siguiente
    </Button>
    }
    {dictTab[nextTab.toString()] === undefined &&
    <Button
      disabled={!validateSend || sending}
      variant="contained"
      color="primary"
      style={{ textTransform: "none", marginLeft: "5px" }}
      onClick={() => sendRequest(true)}
    >
      {sending ? "Enviando..." : "Enviar"}
    </Button>
    }
    <Button
      variant="contained"
      color="primary"
      style={{ textTransform: "none", marginLeft: "5px" }}
    >
      Cancelar
    </Button>
</>



  return (
    <ModalDialog
    open={openModal}
    onClose={closeModal}
    title={`Traslado paciente`}
    _content_={_content_}
    _actions_ = {_actions_}
    maxWidth="lg"
/>
  );
};

export default ModalRequestTraslate;

